@if (options) {
  <ion-grid class="total-container">
    <ion-row>
      <ion-col size="9">{{ 'General.Subtotal' | translate | uppercase }}</ion-col>
      <ion-col size="3" style="text-align: right;">{{ options.subTotal | currency }}</ion-col>
    </ion-row>
    @for (tax of options.taxes; track tax; let i = $index) {
      <ion-row>
        <ion-col size="9">{{ 'General.' + tax.title | translate | uppercase }}</ion-col>
        <ion-col size="3" style="text-align: right;">{{ taxesTotal[i] | currency }}</ion-col>
      </ion-row>
    }
    @if (options.tip) {
      <ion-row>
        <ion-col size="9">{{ 'General.Tip' | translate | uppercase }}</ion-col>
        <ion-col size="3" style="text-align: right;">{{ options.tip | currency }}</ion-col>
      </ion-row>
    }
    @if (options.convenienceFee > 0.00) {
      <ion-row>
        <ion-col size="9">{{ 'Store.ConvenienceFee' | translate | uppercase }}</ion-col>
        <ion-col size="3" style="text-align: right;">{{ options.convenienceFee | currency }}</ion-col>
      </ion-row>
    }
    <ion-row style="margin-top: 10px;">
      <ion-col size="9">{{ 'General.Total' | translate | uppercase }}</ion-col>
      <ng-container>
        <ion-col size="3" style="text-align: right; color:orange;">{{ total | currency }}</ion-col>
      </ng-container>
    </ion-row>
  </ion-grid>
}